var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CContainer',{staticClass:"d-flex align-items-center min-vh"},[_c('CRow',{staticClass:"w-100 justify-content-center"},[_c('CCol',{attrs:{"md":"6"}},[_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"text-center"})])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }